import { h, Component, cloneElement } from 'preact';
import { getConfigForPath } from '../linkevent';

function isDarkMode() {
	return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export class ConfigFromCurrent extends Component {
	componentWillMount() {
		let { theme, current, navigationLinks, useThemeFromWindow, device } = this.props;
		
		let config = {},
			navconfig = current && navigationLinks && getConfigForPath(current, navigationLinks);

		if (navconfig) {
			let { desktop, mobile, ...restconfig } = navconfig;
			let deviceConfigs = { desktop, mobile };
			let deviceSpecific = (device && deviceConfigs[device]) && { ...deviceConfigs[device] } || {};
			config = { ...restconfig, ...deviceSpecific };
		}
		
		if (theme){
			config.theme=theme;
		}
		else if (useThemeFromWindow && !config.theme && isDarkMode()) {
			config.theme='dark';
		}

		if (Object.keys(config).length > 0) this.setState({ config });
	}

	render({ children }, { config }) {
		return cloneElement(children[0], config && { ...config });
	}
}

export default function configFromCurrent(args) {
	return function (Child) {
		function Wrapper(props) {
			return (!props || !props.config) ? (
				<ConfigFromCurrent {...props} {...args}>
					<Child {...props} />
				</ConfigFromCurrent>
			) : (
				<Child {...props} />
			);
		}
		Wrapper.getWrappedComponent = Child && Child.getWrappedComponent || (() => Child);
		return Wrapper;
	};
}

export function applyCurrent() {
	return function (Child) {
		function Wrapper(props) {
			return (
				!props.current && <Child {...props} current={window.location.pathname} /> || <Child {...props} />
			);
		}
		Wrapper.getWrappedComponent = Child && Child.getWrappedComponent || (() => Child);
		return Wrapper;
	};
}